/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Dedup_Create_NewInputs */



/**
* | output |
* | --- |
* | "None match — create new" |
*
* @param {Create_Dedup_Create_NewInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const create_dedup_create_new = /** @type {((inputs?: Create_Dedup_Create_NewInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Dedup_Create_NewInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun ne correspond — créer un nouveau compte")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ninguno coincide — crear cuenta nueva")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum corresponde — criar nova conta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuno corrisponde — crea nuovo account")
	return /** @type {LocalizedString} */ ("None match — create new")
});